import React from 'react';

import { Heading, Slide, Section, preloader } from 'spectacle-ppa';
import TeamNames from 'components/teamNames';

import videoSlide from '../../baseSlides/videoSlide';
import balloonSlide from '../../baseSlides/balloonSlide';

import MarkdownScript from 'helpers/markdownScript';
import markdownFile from './teamCreation.md';

import saraTwistHandsOutHeyHey from '../../images/characters/sara_twist_hands_out_heyhey.png';
import ianArmsFolded from '../../images/characters/ian_arms_folded.png';
import saraGiggle from '../../images/characters/sara_giggle.png';
import ianPointingUp from '../../images/characters/ian_pointing_up.png';

const md = new MarkdownScript(markdownFile);

export function preloadGameShow () {
  preloader([
    saraTwistHandsOutHeyHey,
    ianArmsFolded,
    saraGiggle
  ]);
}

function teamCreationSection ({ regionData }) {
  return (
    <Section id="team-creation">

      {/* Sara and Ian welcome to Academy */}
      {videoSlide({
        id: 'intro-team-names',
        notes: md.getSubSectionAsHtml('Intro Team Names', 'Notes', false, regionData),
        youTubeId: md.getSectionMetadata('Intro Team Names', 'YouTube', regionData)
      })}

      {/* Get into teams and come up with a cool name */}
      {balloonSlide({
        id: 'get-into-teams',
        characterSide: 'right',
        characterImage: saraGiggle,
        notes: md.getSubSectionAsHtml('Get Into Teams', 'Notes', false, regionData),
        html: md.getSubSectionAsHtml('Get Into Teams', 'Content', false, regionData)
      })}

      {/* Enter team names */}
      <Slide
          id="assign"
          bgColor="black"
          notes="<h2>Assign Team Names</h2>"
          teamNames>
        <div className="ui-slide">
          <Heading size={1}>
            Name your teams!
          </Heading>
          <TeamNames />
        </div>
      </Slide>

      {/* Scoring intro */}
      {balloonSlide({
        id: 'scoring-intro',
        characterSide: 'right',
        characterImage: ianArmsFolded,
        notes: md.getSubSectionAsHtml('Scoring Intro', 'Notes', false, regionData),
        html: md.getSubSectionAsHtml('Scoring Intro', 'Content', false, regionData)
      })}

      {/* Introduce scoreboard */}
      {balloonSlide({
        id: 'scoreboard-intro',
        characterSide: 'left',
        characterImage: ianPointingUp,
        notes: md.getSubSectionAsHtml('Scoreboard Intro', 'Notes', false, regionData),
        html: md.getSubSectionAsHtml('Scoreboard Intro', 'Content', false, regionData)
      })}

      {/* Congratulations */}
      {balloonSlide({
        id: 'congratulations',
        characterSide: 'right',
        characterImage: saraTwistHandsOutHeyHey,
        notes: md.getSubSectionAsHtml('Congratulations', 'Notes', false, regionData),
        html: md.getSubSectionAsHtml('Congratulations', 'Content', false, regionData)
      })}

    </Section>

  );
}

export default teamCreationSection;



// WEBPACK FOOTER //
// ./programs/epsPrimaries/sections/10_teamCreation/teamCreationSection.jsx